module.exports = __webpack_public_path__ + "img/khairul.e081a620.jpg";